



import { Component, Vue } from 'vue-property-decorator';
import Teams from '../../assets/teams.svg?inline';
@Component({
  components: {
    Teams,
  },
})
export default class TeamsIcon extends Vue {}
